import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const Termination = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>
        Default, Termination and Return of Deposits
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Where Buyer terminates this Agreement pursuant to any right granted
          by this Agreement, Buyer will be entitled to a return of all deposit
          monies paid on account of Purchase Price, and this Agreement will be
          VOID. Termination of this Agreement may occur for other reasons giving
          rise to claims by Buyer and/or Seller for the deposit monies.
        </Text>

        <Text style={styles.listItem}>
          2. Regardless of the apparent entitlement to deposit monies,{' '}
          {contract?.agentSellerInfo?.propertyState ?? 'N/A'} law does not allow
          a Broker holding deposit monies to determine who is entitled to the
          deposit monies when settlement does not occur. Broker can only release
          the deposit monies:
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            1. If this Agreement is terminated prior to settlement and there is
            no dispute over entitlement to the deposit monies. A written
            agreement signed by both parties is evidence that there is no
            dispute regarding deposit monies.
          </Text>

          <Text style={styles.listItem}>
            2. If, after Broker has received deposit monies, Broker receives a
            written agreement that is signed by Buyer and Seller, directing
            Broker how to distribute some or all of the deposit monies.
          </Text>

          <Text style={styles.listItem}>
            3. According to the terms of a final order of court.
          </Text>

          <Text style={styles.listItem}>
            d. According to the terms of a prior written agreement between Buyer
            and Seller that directs the Broker how to distribute the deposit
            monies if there is a dispute between the parties that is not
            resolved.
          </Text>
        </View>

        <Text style={styles.listItem}>
          3. Buyer and Seller agree that if there is a dispute over the
          entitlement to deposit monies that is unresolved{' '}
          <Text style={styles.DangerText}>30 days</Text> after the Settlement
          Date stated in this agreement (or any written extensions thereof) or
          following termination of the Agreement, whichever is earlier, then the
          Broker holding the deposit monies will, within 30 days of receipt of
          Buyer's written request, distribute the deposit monies to Buyer unless
          the Broker is in receipt of verifiable written notice that the dispute
          is the subject of litigation or mediation. If Broker has received
          verifiable written notice of litigation or mediation prior to the
          receipt of Buyer's request for distribution, Broker will continue to
          hold the deposit monies until receipt of a written distribution
          agreement between Buyer and Seller or a final court order. Buyer and
          Seller are advised to initiate litigation or mediation for any portion
          of the deposit monies prior to any distribution made by Broker
          pursuant to this paragraph. Buyer and Seller agree that the
          distribution of deposit monies based upon the passage of time does not
          legally determine entitlement to deposit monies, and that the parties
          maintain their legal rights to pursue litigation even after a
          distribution is made.
        </Text>

        <Text style={styles.listItem}>
          4. Buyer and Seller agree that a Broker who holds or distributes
          deposit monies pursuant to the terms of this agreement or California
          law will not be liable. Buyer and Seller agree that if any Broker or
          affiliated licensee is named in litigation regarding deposit monies,
          the attorneys' fees and costs of the Broker(s) and licensee(s) will be
          paid by the party naming them in litigation.
        </Text>

        <Text style={styles.listItem}>
          5. Seller has the option of retaining all sums paid by Buyer,
          including the deposit monies, should Buyer:
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            1. Fail to make any payments as specified, OR
          </Text>

          <Text style={styles.listItem}>
            2. Furnish false or incomplete information to Seller, Broker(s), or
            any other party identified in this Agreement concerning Buyer's
            legal or financial status
          </Text>

          <Text style={styles.listItem}>
            3. Violate or fail to fulfill and perform any other terms or
            conditions of this Agreement.
          </Text>
        </View>

        <Text style={styles.listItem}>
          6. Unless otherwise determined in this agreement, Seller may elect to
          retain those sums paid by Buyer, including deposit monies:
        </Text>

        <View style={styles.list}>
          <Text style={styles.listItem}>
            1. On account of purchase price, OR
          </Text>

          <Text style={styles.listItem}>
            2. As monies to be applied to Seller's damages, OR
          </Text>

          <Text style={styles.listItem}>
            3. As liquidated damages for such default.
          </Text>
        </View>

        <Text style={styles.listItem}>
          7. Seller is limited to retaining sums paid by buyer, including
          deposit monies, as liquidated damages.
        </Text>

        <Text style={styles.listItem}>
          8. If Seller retains all sums paid by Buyer, including deposit monies,
          as liquidated damages, Buyer and Seller are released from further
          liability or obligation and this Agreement is VOID.
        </Text>

        <Text style={styles.listItem}>
          9. Brokers and licensees are not responsible for unpaid deposits.
        </Text>
      </View>
    </View>
  );
};

export default Termination;
